import { formatDate, formatTimeText } from '../../utils/dateDisplay'

export const APP_NOTICE_IMAGE_FILE_ERROR_MESSAGE = '이미지 파일만 업로드할 수 있습니다.'
export const APP_NOTICE_IMAGE_PREVIEW_ERROR_MESSAGE = '이미지 미리보기를 만들지 못했습니다.'
export const APP_NOTICE_IMAGE_FILE_ACCEPT = '.jpg,.jpeg,.png,.gif,.webp,image/png,image/gif,image/jpeg,image/webp'
export const DEFAULT_APP_NOTICE_SEARCH_SELECT = {
    searchStatus: '',
    searchPopupStatus: '',
}

const normalizeTextValue = (value) => (value || '').trim()

// App 공지사항 이미지 업로드에서 허용하는 파일 형식만 통과시킨다.
export const isAppNoticeImageFile = (file) => {
    if (!file) {
        return false
    }

    return (file.type && file.type.startsWith('image/')) || /\.(jpg|jpeg|png|gif|webp)$/i.test(file.name || '')
}

// File 객체를 화면 미리보기용 data URL로 변환한다.
export const readAppNoticeImagePreview = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()

        reader.onloadend = () => {
            resolve(reader.result || '')
        }

        reader.onerror = () => {
            reject(reader.error)
        }

        reader.readAsDataURL(file)
    })
}

// 저장 전 공통 필드 정리를 한 곳에서 처리해 등록/수정 검증 기준을 맞춘다.
export const createNormalizedAppNoticeParams = (params = {}) => ({
    ...params,
    title: normalizeTextValue(params.title),
    content: normalizeTextValue(params.content),
})

// 등록/수정 저장 전 필수 입력 조건을 검증하고 운영자에게 보여줄 문구를 반환한다.
export const getAppNoticeValidationMessage = (params = {}) => {
    if (!params.title) {
        return '제목을 입력하세요.'
    }

    if (!params.content) {
        return '내용을 입력하세요.'
    }

    if (Number(params.popupStatus) === 1 && !params.popupImage) {
        return '팝업이미지를 등록해주세요.'
    }

    if (Number(params.popupStatus) === 1 && (!params.startTime || !params.endTime)) {
        return '팝업 노출 기간을 입력하세요.'
    }

    return ''
}

// 등록/수정 API가 기대하는 multipart payload를 같은 규칙으로 만든다.
export const createAppNoticeFormData = (params = {}, { noticeId, push = 0 } = {}) => {
    const formData = new FormData()

    if (noticeId !== undefined && noticeId !== null) {
        formData.append('noticeId', noticeId)
    }

    formData.append('image', params.image)
    formData.append('popupImage', params.popupImage)
    formData.append('deviceType', params.deviceType)
    formData.append('cCode', params.cCode)
    formData.append('title', params.title)
    formData.append('content', params.content)
    formData.append('status', params.status)
    formData.append('popupStatus', params.popupStatus)
    formData.append('startTime', params.startTime)
    formData.append('endTime', params.endTime)
    formData.append('push', push)

    return formData
}

// 목록의 팝업 상태값을 운영자가 바로 이해할 수 있는 문구로 바꾼다.
export const getAppNoticePopupStatusLabel = (popupStatus) => {
    return Number(popupStatus) === 1 ? '팝업' : '미팝업'
}

// 목록의 노출 상태값을 운영자가 바로 이해할 수 있는 문구로 바꾼다.
export const getAppNoticeStatusLabel = (status) => {
    return Number(status) === 1 ? '노출' : '미노출'
}

// 서버 deviceType 코드를 목록 표시 문구로 변환한다.
export const getAppNoticeDeviceTypeLabel = (deviceType) => {
    if (deviceType === 'all') {
        return '전체'
    }

    if (deviceType === 'and') {
        return 'Android'
    }

    if (deviceType === 'ios') {
        return 'iOS'
    }

    return '-'
}

// 국가 코드를 목록 표시 문구로 변환한다.
//   00은 과거 데이터에만 있고 지금은 선택지로 주지 않는다.
//   모르는 코드는 코드 그대로 보여준다 — '해외'로 뭉뚱그리면 특정 국가 공지가
//   전체 공지처럼 보여서, 노출 범위를 화면만 보고 판단할 수 없게 된다.
const APP_NOTICE_COUNTRY_LABELS = {
    kr: '국내',
    99: '기타 해외',
    '00': '전체',
    th: '태국',
}

export const getAppNoticeCountryLabel = (countryCode) => {
    if (!countryCode) {
        return '-'
    }

    return APP_NOTICE_COUNTRY_LABELS[countryCode] || countryCode
}

// 등록일 값이 비어도 목록 렌더링이 깨지지 않도록 날짜와 시간을 안전하게 분리한다.
export const formatAppNoticeRegTime = (regTime) => {
    if (!regTime) {
        return {
            date: '-',
            time: '',
        }
    }

    const regTimeText = String(regTime)

    return {
        date: formatDate(regTimeText),
        time: formatTimeText(regTimeText),
    }
}

// 팝업 공지가 아닐 때는 기간을 비워두고, 팝업 공지 기간은 null-safe하게 보여준다.
export const formatAppNoticePopupPeriod = ({ popupStatus, startTime, endTime } = {}) => {
    if (Number(popupStatus) !== 1) {
        return {
            startTime: '',
            endTime: '',
        }
    }

    return {
        startTime: startTime || '-',
        endTime: endTime || '-',
    }
}
